import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withRouter } from "react-router-dom"
import { countBy, isEmpty, size } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Dropzone from "react-dropzone"
import { withTranslation } from "react-i18next"
import maintanence from "../../../assets/images/coming-soon.svg"
import toastr from "toastr";
import toast, { Toaster } from 'react-hot-toast';


import
paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { Link } from "react-router-dom"
import * as moment from 'moment';
import Select from "react-select"
import jsPDF from "jspdf";
import "jspdf-autotable";
import Moment from 'moment';
import { FormText, Alert, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, InputGroup, Input, FormGroup, Label, Button, Card, CardBody, Col, Table, ModalFooter, Container, Row, Modal, Badge, ModalHeader, ModalBody } from "reactstrap"


// Add the Firebase products that you want to use
import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/database"
import "firebase/storage"

import { AvForm, AvField } from "availity-reactstrap-validation"
import SweetAlert from "react-bootstrap-sweetalert"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  getRepair,
  addNewRepair,
  updateRepair,
  deleteRepair,
  getVehicle,
  getSupplier,
  updateVehicle,
  getReservation
} from "store/actions"


import exportFromJSON from 'export-from-json'
import { isThisExpression } from "@babel/types";
import { vehicle12 } from "assets/images/vehicle";

class Repairs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currency: "",
      p_loading: false,
      modalDenied: false,
      repairPermissions: null,
      user_id: "",
      selectedPeriod: "day",
      selectedVehicleName: "All Vehicles",
      selectedVehicle1: 1,
      selectedDate: "",
      selectedTS: null,
      selectedOption: "todo",
      modal1: false,
      currentYear: new Date().getFullYear(),
      SD: new Date(),
      ED: new Date().setDate(new Date().getDate() + 1),
      SDChanged: false,
      EDChanged: false,
      ibadl: false,
      loading: true,
      submitLoading: false,
      isShow: false,
      changed: false,
      vcchanged: false,
      wschanged: false,
      gender: "",
      viewmodal: false,
      modal: false,
      isDelete: false,
      no_data: false,
      success_dlg: false,
      dynamic_title: '',
      dynamic_description: '',
      vc: "",
      selectedType: null,
      selectedVehicle: null,
      selectedWorkshop: null,
      repairs: [],
      repair: [],
      vehicles: [],
      workshops: [],
      reservations: [],
      vehList: [],
      date_birth: new Date(),
      reqNext: false,
      RepairColumns: [
        {
          dataField: "vehicle",
          text: this.props.t("Vehicle"),
          sort: true,
          formatter: (cellContent, row) => (
            <Link to="#" className="text-body fw-bold">
              {row.vehicle}
            </Link>
          ),
        },
        {
          dataField: "type",
          text: this.props.t("Maintenance Type"),
          sort: true,
          formatter: (cellContent, row) => (

            <>
              <i className={
                row.type === "Maintenance" ? "fas fa-brush me-1" :
                  row.type === "Repair" ? "fas fa-wrench me-1" :
                    row.type === "Oil change" ? "fas fa-oil-can me-1" :
                      row.type === "Accident repair" ? "fas fa-car-crash me-1" :
                        row.type === "Inspection" ? "fas fa-search me-1" :
                          "fas fa-question me-1" // Fallback icon
              } />{" "}
              {this.props.t(row.type)}
            </>

          ),
        },
        {
          dataField: "createdAt",
          text: this.props.t("Date created"),
          sort: true,
          formatter: (cellContent, row) => (
            <>

              {" "}
              {moment(row.createdAt).format('YYYY-MM-DDTHH:mm')}
            </>
          ),
        },
        {
          dataField: "workshop",
          text: this.props.t("Workshop"),
          sort: true,
        },


        {
          dataField: "start_date",
          text: this.props.t("Date"),
          sort: true,
        },


        {
          dataField: "amount",
          text: this.props.t("Total amount"),
          sort: true,
          formatter: (cellContent, row) => (
            <>
              {" "}
              {row.amount} {this.state.currency || ""}
            </>
          ),
        },

        {
          dataField: "view",
          isDummyField: true,
          text: this.props.t("View Details"),
          sort: true,
          formatter: (cellContent, repair) => (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={() => this.handleViewClick(repair)}
            >
              {this.props.t("View Details")}
            </Button>
          ),
        },
        {
          dataField: "action",
          isDummyField: true,
          text: this.props.t("Action"),
          formatter: (cellContent, repair) => (
            <>

              <div className="d-flex gap-3">
                <Link to="#" className="text-success">
                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" onClick={() => this.handleRepairClick(repair)} />
                </Link>
                <Link to="#" className="text-danger">
                  <i className="mdi mdi-delete font-size-18" id="deletetooltip" onClick={() => this.handleDeleteClick(repair)} />
                </Link>
              </div>
            </>
          ),
        },
      ],
      documents: {
        repair: null,
        receipt: null,
        other: null
      },
      previews: {
        repair: null,
        receipt: null,
        other: null
      },
      errors: {
        repair: null,
        receipt: null,
        other: null
      },
      selectedFiles: {
        repair: null,
        receipt: null,
        other: null
      },
      uploadProgress: {
        repair: 0,
        receipt: 0,
        other: 0
      }
    }
    this.toggleDenied = this.toggleDenied.bind(this)
    this.handleRepairClick = this.handleRepairClick.bind(this)
    this.toggle = this.toggle.bind(this)
    this.handleValidRepairSubmit = this.handleValidRepairSubmit.bind(this)
    this.handleRepairClicks = this.handleRepairClicks.bind(this)
    this.toLowerCase1 = this.toLowerCase1.bind(this)
    this.toggleDelete = this.toggleDelete.bind(this)
    this.handleViewClick = this.handleViewClick.bind(this)
    this.handleSelectType = this.handleSelectType.bind(this)
    this.handleSelectVehicle = this.handleSelectVehicle.bind(this)
    this.handleSelectWorkshop = this.handleSelectWorkshop.bind(this)
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this)
    this.toggleIsShow = this.toggleIsShow.bind(this)
    this.toggle_modal = this.toggle_modal.bind(this)
    this.onValueChange = this.onValueChange.bind(this)
    this.handleValidEventSubmit = this.handleValidEventSubmit.bind(this)
    this.handleSelectVehicleFilter = this.handleSelectVehicleFilter.bind(this)
  }

  toggleDenied() {
    this.setState(prevState => ({
      modalDenied: !prevState.modalDenied,
    }))
  }
  handleDeleteClick = (repair) => {

    const { repairPermissions, p_loaded } = this.state;

    if (!p_loaded) {
      return; // Exit early if permissions are not yet loaded
    }

    if (repairPermissions === null || repairPermissions.delete) {
      this.setState({ isDelete: true, vc: repair });
    } else {
      this.setState({ modalDenied: true }, () => {
       //console..log("Permission denied");
      });
    }

  };
  onValueChange(event) {
    const { notifs } = this.state
    this.setState({
      selectedOption: event.target.id
    });
   //console..log(event.target.id)

  }
  dateChanged = d => {
    /*  const { vehicles, rdchanged, RD } = this.state
     this.setState({ PD: d.target.value })*/
    this.setState({
      selectedTS: moment(d.target.value, 'YYYY-MM-DD').valueOf(),
      selectedDate: d.target.value,
      selectedOption: "dia"
    })

    //console.log(d.target.value)
  }
  monthChanged = d => {

    this.setState({
      selectedTS: moment(d.target.value, 'YYYY-MM').valueOf(),
      selectedDate: d.target.value,
      selectedOption: "mes"
    })

    //console.log(d.target.value)
  }
  toggle_modal() {
    this.setState(prevState => ({
      modal1: !prevState.modal1,
    }))
    this.removeBodyCss()
  }

  removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  handlePeriodChange = (e) => {
    this.setState({
      selectedPeriod: e.target.value
    })
    //console.log(e.target.value);
  };
  handleValidEventSubmit = (e, values) => {

    //console.log(values)
    if (values.period === "day") {
      this.setState({
        selectedTS: moment(values.date, 'YYYY-MM-DD').valueOf(),
        selectedOption: "dia",
        selectedDate: values.date,
      })
    }
    if (values.period === "month") {
      this.setState({
        selectedTS: moment(values.month, 'YYYY-MM').valueOf(),
        selectedOption: "mes",
        selectedDate: values.month,
      })
    }
    if (values.period === "year") {
      this.setState({
        selectedTS: moment(values.year, 'YYYY').valueOf(),
        selectedOption: "ano",
        selectedDate: values.year,
      })
    }



    this.toggle_modal()
  }
  handleSelectVehicleFilter = (selectedVehicle, value) => {
    const { vehicles } = this.state
    /*  let kra = selectedVehicle.target.value
     let plt = kra.substring(kra.indexOf("(") + 1, kra.indexOf(")")) */
    //console.log(value)
    if (value === 'All vehicles') {
      this.setState({

        selectedVehicleName: "All Vehicles",
        selectedVehicle1: 1
      })
    } else {
      const p = vehicles.find(v => v.id === value);
      var plt = ""
      if (p !== undefined) {
        plt = p.plate_number
      }
      let m = 0

      const name = p.make + " " + p.model + " ( " + p.plate_number + " )"
      //console.log(name)
      vehicles.map((e, key) => {

        if (e.plate_number === plt) {
          m = e.mileage
        }
      })
      this.setState({
        mile: m,
        selectedVehicleName: name,
        selectedVehicle1: value
      })
    }

  }
  handleSDChange = SD => {
    const { vehicles, EDChanged, ED, isEdit, repair } = this.state
    this.setState({ SD: SD.target.value })
    this.setState({ SDChanged: true })
    // vehList

  }

  handleEDChange = ED => {
    const { vehicles, SDChanged, SD } = this.state
    this.setState({ ED: ED.target.value })
    this.setState({ EDChanged: true })
    // vehList
  }


  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    )

    this.setState({ selectedFiles: files })
  }

  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  toLowerCase1(str) {
    return str.toLowerCase();
  }
  handleSelectType = selectedType => {
    //console.log(selectedType.target.value)
    if (selectedType.target.value === "Oil change" || selectedType.target.value === "Inspection") {

      this.setState({
        reqNext: true
      })
    } else {
      this.setState({
        reqNext: false
      })
    }

  }
  handleSelectVehicle = selectedVehicle => {

    //this.setState({ selectedVehicle: selectedVehicle })
    //console.log(selectedVehicle.target.value)
  }
  handleSelectWorkshop = selectedWorkshop => {

    this.setState({ selectedWorkshop: selectedWorkshop })
    this.setState({ wschanged: true })
  }
  componentDidMount() {
    const { repairs, onGetRepair } = this.state
    if (repairs && !repairs.length) {
      // onGetRepair()
      this.getRepair()
    }
    this.setState({ repairs })
    const { vehicles, onGetVehicle } = this.state
    if (vehicles && !vehicles.length) {
      // onGetVehicle()
      this.getVehicle()
    }
    this.setState({ vehicles })
    const { workshops, onGetSupplier } = this.state
    if (workshops && !workshops.length) {
      //onGetSupplier()
      this.getSupplier()
    }
    this.setState({ workshops })
    const { reservations, onGetReservation } = this.state
    if (reservations && !reservations.length) {
      //onGetReservation()
      this.getReservation()
    }
    this.getRepairPermissions()
  }
  async getRepairPermissions() {
    try {
      this.setState({ p_loaded: false })
      firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          const userId = user.uid;
          // Reference to the user document
          const userDocRef = firebase.firestore().collection("users").doc(userId);

          // Fetch the user document
          const userSnapshot = await userDocRef.get();

          if (!userSnapshot.exists) {
            this.setState({ p_loaded: true })
           //console..log("User document does not exist.");
            return null; // Return null if user document doesn't exist
          }

          const userData = userSnapshot.data();

          // Check if the user is an admin
          if (userData.isAdmin) {
            this.setState({ p_loaded: true })
            //console.log("User is an admin; permissions are not restricted.");
            return null; // Return null or handle differently for admins
          } else {
            const userD = await firebase.firestore().collection("users").doc(userData.id).get();
            //console.log(userD.data())
            this.setState({ currency: userD.data().currency })
          }

          // Reference to the permissions document for 'clients'
          const permissionsDocRef = userDocRef.collection("permissions").doc("maintenance");

          // Fetch the document
          const permissionsSnapshot = await permissionsDocRef.get();

          if (permissionsSnapshot.exists) {
            const repairPermissions = permissionsSnapshot.data();
            /////console..log("Client Permissions:", clientPermissions);
            this.setState({ repairPermissions });
            this.setState({ p_loaded: true })
            return repairPermissions; // Return the permissions as an object
          } else {
            this.setState({ p_loaded: true })
           //console..log("No permissions found for 'maintenance'.");
            return null; // Return null if no permissions exist
          }
        } else {
          this.setState({ p_loaded: true })
         //console..log("Not authenthicated")
        }
      })

    } catch (error) {
      this.setState({ p_loaded: true })
     //console..error("Error fetching maintenance permissions:", error);
      throw error;
    }
  }

  getRepair = async () => {
    this.setState({ loading: true });
    const branch = JSON.parse(localStorage.getItem("branch"));

    if (branch !== undefined && branch !== "") {
      // Unsubscribe previous listeners to prevent memory leaks
      if (this.unsubscribeRepairs) {
        this.unsubscribeRepairs();
      }

      this.unsubscribeRepairs = firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          const userId = user.uid;
          const usersCollection = firebase.firestore().collection("users")
          const userDocRef = usersCollection.doc(userId);

          try {
            const userDoc = await userDocRef.get();
            if (userDoc.exists) {
              const userId = userDoc.data().id;
              this.setState({ currency: userDoc.data().currency })
              const userRepairsCollectionRef = usersCollection.doc(userId).collection("repairs").where("branchId", "==", branch);
              this.setState({
                account_user: userDoc.data()
              })
              this.unsubscribeRepairs = userRepairsCollectionRef.onSnapshot(snapshot => {
                let kra = []
                snapshot.docs.forEach(e => {
                  kra.push(e.data())
                });
                this.setState({
                  loading: false,
                  repairs: kra,
                })
              })

             // localStorage.setItem("authUser", JSON.stringify(user))
            } else {
             //console..log("not user")
              localStorage.removeItem("authUser")
            }
          } catch (error) {
           //console..error("Error fetching user document:", error);
            // Handle error
          }
        }

      })
    } else {
      //toast.error("Error")
this.setState({loading: false,});
    }


  }

  getVehicle = async () => {
    this.setState({ loading: true });
    const branch = JSON.parse(localStorage.getItem("branch"));

    if (branch !== undefined && branch !== "") {
      // Unsubscribe previous listeners to prevent memory leaks
      if (this.unsubscribeVehicles) {
        this.unsubscribeVehicles();
      }

      this.unsubscribeVehicles = firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          const userId = user.uid;
          const usersCollection = firebase.firestore().collection("users")
          const userDocRef = usersCollection.doc(userId);

          try {
            const userDoc = await userDocRef.get();
            if (userDoc.exists) {
              const userId = userDoc.data().id;
              this.setState({ currency: userDoc.data().currency })
              const userVehiclesCollectionRef = usersCollection.doc(userId).collection("vehicles").where("branchId", "==", branch);
              this.setState({
                user_id: userId
              })
              this.unsubscribeVehicles = userVehiclesCollectionRef.onSnapshot(snapshot => {
                let vehicles = [];
                snapshot.docs.forEach(doc => {
                  vehicles.push(doc.data());
                });

                this.setState({
                  loading: false,
                  vehicles: vehicles
                });
              });

              //localStorage.setItem("authUser", JSON.stringify(user));
            } else {
              // User document not found
              localStorage.removeItem("authUser");
              this.setState({
                loading: false,
                vehicles: []
              });
            }
          } catch (error) {
           //console..error("Error fetching user document:", error);
            // Handle error
          }
        } else {
          localStorage.removeItem("authUser");
          // Clear the reservations if user is not authenticated
          this.setState({
            loading: false,
            vehicles: []
          });
        }
      });
    } else {
      //toast.error("Error")
this.setState({loading: false,});
    }

  }
  getSupplier = async () => {
    this.setState({ loading: true });
    const branch = JSON.parse(localStorage.getItem("branch"));

    if (branch !== undefined && branch !== "") {
      // Unsubscribe previous listeners to prevent memory leaks
      if (this.unsubscribeSuppliers) {
        this.unsubscribeSuppliers();
      }

      this.unsubscribeSuppliers = firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          const userId = user.uid;
          const usersCollection = firebase.firestore().collection("users")
          const userDocRef = usersCollection.doc(userId);

          try {
            const userDoc = await userDocRef.get();
            if (userDoc.exists) {
              const userId = userDoc.data().id;
              this.setState({ currency: userDoc.data().currency })
              const userSuppliersCollectionRef = usersCollection.doc(userId).collection("workshops").where("branchId", "==", branch);
              this.setState({
                user_id: userId
              })
              this.unsubscribeSuppliers = userSuppliersCollectionRef.onSnapshot(snapshot => {
                let n = [];
                snapshot.docs.forEach(doc => {
                  n.push(doc.data());
                });

                this.setState({
                  loading: false,
                  workshops: n
                });
              });

              //localStorage.setItem("authUser", JSON.stringify(user));
            } else {
              // User document not found
              localStorage.removeItem("authUser");

              this.setState({
                loading: false,
                workshops: []
              });

            }
          } catch (error) {
           //console..error("Error fetching user document:", error);
            // Handle error
          }
        } else {
          localStorage.removeItem("authUser");
          // Clear the reservations if user is not authenticated
          this.setState({
            loading: false,
            workshops: []
          });
        }
      });
    } else {
      //toast.error("Error")
this.setState({loading: false,});
    }

  }
  getReservation = async () => {
    this.setState({ loading: true });
    const branch = JSON.parse(localStorage.getItem("branch"));

    if (branch !== undefined && branch !== "") {
      // Unsubscribe previous listeners to prevent memory leaks
      if (this.unsubscribeReservations) {
        this.unsubscribeReservations();
      }

      this.unsubscribeReservations = firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          const userId = user.uid;
          const usersCollection = firebase.firestore().collection("users")
          const userDocRef = usersCollection.doc(userId);
          this.setState({
            user_id: userId
          })
          try {
            const userDoc = await userDocRef.get();
            if (userDoc.exists) {
              const userId = userDoc.data().id;
              this.setState({ currency: userDoc.data().currency })
              const userReservationsCollectionRef = usersCollection.doc(userId).collection("reservations").where("branchId", "==", branch);

              this.unsubscribeReservations = userReservationsCollectionRef.onSnapshot(snapshot => {
                let reservations = [];
                snapshot.docs.forEach(doc => {
                  reservations.push(doc.data());
                });

                this.setState({
                  loading: false,
                  reservations: reservations
                });
              });

              //localStorage.setItem("authUser", JSON.stringify(user));
            } else {
              // User document not found
              localStorage.removeItem("authUser");
              this.setState({
                loading: false,
                reservations: []
              });
            }
          } catch (error) {
           //console..error("Error fetching user document:", error);
            // Handle error
          }
        } else {
          localStorage.removeItem("authUser");
          // Clear the reservations if user is not authenticated
          this.setState({
            loading: false,
            reservations: []
          });
        }
      });
    } else {
      //toast.error("Error")
this.setState({loading: false,});
    }

  }


  // eslint-disable-next-line no-unused-vars
  /* componentDidUpdate(prevProps, prevState, snapshot) {
    const { repairs } = this.state
    const { vehicles } = this.state
    const { workshops } = this.state
    const { reservations } = this.state

    if (!isEmpty(repairs) && size(prevProps.repairs) !== size(repairs)) {
      // this.setState({ repairs: {}, isEdit: false })
    }
    if (!isEmpty(vehicles) && size(prevProps.vehicles) !== size(vehicles)) {
      // this.setState({ vehicles: {}, isEdit: false })
    }
    if (!isEmpty(workshops) && size(prevProps.workshops) !== size(workshops)) {
      // this.setState({ workshops: {}, isEdit: false })
    }
  } */

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }))
  }
  toggleDelete() {
    this.setState(prevState => ({
      isDelete: !prevState.isDelete,
    }))
  }

  handleRepairClicks = () => {

    const { repairPermissions, p_loaded } = this.state;

    if (!p_loaded) {
      return; // Exit early if permissions are not yet loaded
    }

    if (repairPermissions === null || repairPermissions.add) {
      this.setState({ vehList: [], repair: [], isEdit: false, isShow: false, selectedWorkshop: null, selectedVehicle: null, selectedRepair: null }, () => {
        this.toggle(); // Ensure toggle is called after state updates
      });
    } else {
      this.setState({ modalDenied: true }, () => {
       //console..log("Permission denied");
      });
    }


  }

  // eslint-disable-next-line no-unused-vars
  handleTableChange = (type, { page, searchText }) => {
    const { repairs } = this.state
    this.setState({
      repairs: repairs.filter(repair =>
        Object.keys(repair).some(
          key =>
            typeof repair[key] === "string" &&
            repair[key].toLowerCase().includes(searchText.toLowerCase())
        )
      ),
    })
  }

  toggleViewModal = () => {
    this.setState(prevState => ({
      viewmodal: !prevState.viewmodal,
    }))
  }

  toggleIsShow = () => {
    this.setState(prevState => ({
      isShow: !prevState.isShow,
    }))
  }


  /* Insert,Update Delete data */

  handleDeleteRepair = (repair) => {


    //const { onDeleteRepair } = this.props
    /*  if (repair['code'] === '') {
       //
     } else { */
    this.deleteRepair(repair)
    // toast.success(this.props.t("Item Deleted "))
    this.toggleDelete()
    // }

  }

  handleViewClick = arg => {
    const repair = arg
    const repair_url = repair.repairDoc ? repair.repairDoc.url : ""
    const rec_url = repair.receiptDoc ? repair.receiptDoc.url : ""
    const other_url = repair.otherDoc ? repair.otherDoc.url : ""
    this.setState({ selectedType: { label: repair.type, value: repair.type } })
    this.setState({ selectedVehicle: { label: repair.vehicle, value: repair.plate_number } })
    this.setState({ selectedWorkshop: { label: repair.workshop, value: repair.workshop_id } })
    this.setState({
      repair: {
        id: repair.id,
        //label: repair.label,
        workshop: repair.workshop,
        workshop_id: repair.workshop_id,
        vehicle: repair.vehicle,
        v_id: repair.v_id,
        plate_number: repair.plate_number,
        start_date: repair.start_date,
        start: repair.start_date,
        end: repair.end_date,
        title: repair.type + " - " + repair.vehicle,
        tenDays: repair.tenDays,
        sd: repair.sd,
        ed: repair.ed,
        end_date: repair.end_date,
        next_date: repair.next_date,
        payment_date: repair.payment_date,
        pd: repair.pd,
        amount: repair.amount,
        //purchase_order: repair.purchase_order,
        details: repair.details,
        type: repair.type,
        status: repair.status,
        repair_url: repair_url,
        rec_url: rec_url,
        other_url: other_url
        /* reciept:repair.reciept,
        invoice:repair.invoice */
      },

      isShow: true,
      isEdit: false

    })

    //this.toggleIsShow()
    this.toggle()

    //this.toggleViewModal()
  }


  handleRepairClick = arg => {

    const { repairPermissions, p_loaded } = this.state;

    if (!p_loaded) {
      return; // Exit early if permissions are not yet loaded
    }

    if (repairPermissions === null || repairPermissions.update) {
      const repair = arg

      const repair_url = repair.repairDoc ? repair.repairDoc.url : ""
      const rec_url = repair.receiptDoc ? repair.receiptDoc.url : ""
      const other_url = repair.otherDoc ? repair.otherDoc.url : ""
      const { vehicles, vehList } = this.state

      const found = vehicles.find(item => item.plate_number === repair.plate_number);
      var tmp = []
      tmp = vehList
      tmp.push(found)


      this.setState({ selectedType: { label: repair.type, value: repair.type } })
      this.setState({ selectedVehicle: { label: repair.vehicle, value: repair.plate_number } })
      this.setState({ selectedWorkshop: { label: repair.workshop, value: repair.workshop_id } })
      this.setState({
        repair: {
          id: repair.id,
          // label: repair.label,
          workshop: repair.workshop,
          workshop_id: repair.workshop_id,
          vehicle: repair.vehicle,
          plate_number: repair.plate_number,
          start_date: repair.start_date,
          start: repair.start_date,
          end: repair.end_date,
          title: repair.type + " - " + repair.vehicle,
          sd: repair.sd,
          ed: repair.ed,
          end_date: repair.end_date,
          next_date: repair.next_date,
          payment_date: repair.payment_date,
          pd: repair.pd,
          amount: repair.amount,
          //purchase_order: repair.purchase_order,
          details: repair.details,
          type: repair.type,
          status: repair.status,
          repair_url: repair_url,
          rec_url: rec_url,
          other_url: other_url
          /* reciept:repair.reciept,
          invoice:repair.invoice */
        },
        selectedFiles: {
          repair: null,
          receipt: null,
          other: null
        },
        isEdit: true,
        isShow: false,
        vehList: tmp
      })

      this.toggle()
    } else {
      this.setState({ modalDenied: true }, () => {
       //console..log("Permission denied");
      });
    }


  }

  /**
   * Handling submit Order on Order form
   */
  handleValidRepairSubmit = (e, values) => {
    const { onAddNewRepair, onUpdateRepair } = this.state
    const { onUpdateVehicle } = this.state
    const { isEdit, repairs, selectedRepair, vehicles } = this.state

    var stda = new Date(values.start_date).getTime()
    var enda = new Date(values.end_date).getTime()
    var p_d = new Date(values.payment_date).getTime()
    var nd = values.next_date === undefined ? 4877277322991 : new Date(values.next_date).getTime();
    const tenDays = nd - 10 * 24 * 60 * 60 * 1000;


    let stts = ""
    var pd = new Date(values.start_date);
    var today = new Date();
    var rd = new Date(values.end_date);

    if (rd.getTime() > today.getTime() && pd.getTime() > today.getTime()) {
      stts = "created"
     //console..log(stts)
    }
    if (pd.getTime() < today.getTime() && rd.getTime() > today.getTime()) {
      // //console.log("stattus changed ")
      stts = "repair"
      // //console.log(stts)
    }
    if (today.getTime() > rd.getTime() && today.getTime() > pd.getTime()) {
      stts = "done"
     //console..log(stts)
    }

    const p = vehicles.find(v => v.id === values.vehicle);
    var plt = ""
    var vehicle = ""
    if (p !== undefined) {
      plt = p.plate_number
      vehicle = p.make + " (" + p.plate_number + ")"
    }


    let wor = ""
    if (this.state.selectedWorkshop != null) {
      if (this.state.wschanged) {
        wor = this.state.selectedWorkshop.label
        this.setState({ wschanged: false })
      } else {
        wor = this.state.selectedWorkshop.label
      }
    }

    let worid = ""
    if (this.state.selectedWorkshop != null) {
      if (this.state.wschanged) {
        worid = this.state.selectedWorkshop.value
        this.setState({ wschanged: false })
      } else {
        worid = this.state.selectedWorkshop.value
      }
    }

    //console.log(values.type)
    var am = parseInt(values.amount)

    if (isEdit) {
      //des=this.state.selectedType.defaultInputValue
      var nd = ""
      if (values.next_date !== undefined) {
        nd = values.next_date
      }
      const updateRepair = {
        id: this.state.repair.id,
        //label: values.label,
        workshop: wor,
        workshop_id: worid,
        tenDays: tenDays,
        /* vehicle: vehicle,
        v_id:values.vehicle,
        plate_number: plt, */
        vehicle: this.state.repair.vehicle,
        start_date: values.start_date,
        start: values.start_date,
        end: values.end_date,
        title: values.type + " - " + values.vehicle,
        sd: stda,
        ed: enda,
        end_date: values.end_date,
        next_date: nd,
        payment_date: values.payment_date,
        pd: p_d,
        amount: am,
        repair: this.state.selectedFiles.repair,
        receipt: this.state.selectedFiles.receipt,
        other: this.state.selectedFiles.other,
        //purchase_order: values.purchase_order,
        details: values.details,
        type: values.type,
        status: stts,

        /*   reciept:values.reciept,
          invoice:values.invoice */


      }
     //console..log(this.state.repair.next_date == updateRepair.next_date, this.state.repair.next_date, updateRepair.next_date)
      // update Order
      if (/*this.state.repair.label == updateRepair.label && 
        this.state.repair.vehicle == updateRepair.vehicle && */
        this.state.repair.start_date == updateRepair.start_date &&
        this.state.repair.end_date == updateRepair.end_date &&
        this.state.repair.next_date == updateRepair.next_date &&
        this.state.repair.payment_date == updateRepair.payment_date &&
        this.state.repair.amount == updateRepair.amount &&
        this.state.repair.type == updateRepair.type &&
        updateRepair.repair == null &&
        updateRepair.receipt == null &&
        updateRepair.other == null &&
        //this.state.repair.purchase_order == updateRepair.purchase_order &&
        this.state.repair.details == updateRepair.details) {
        this.setState({ submitLoading: false })
        this.toggle()
      } else {
        this.updateRepair(updateRepair)
      }
    } else {

      const newRepair = {

        //label: values["label"],
        workshop: wor,
        workshop_id: worid,
        v_id: values["vehicle"],
        vehicle: vehicle,
        plate_number: plt,
        start_date: values['start_date'],
        start: values['start_date'],
        end: values['end_date'],
        title: values["type"] + " - " + vehicle,
        tenDays: tenDays,
        sd: stda,
        ed: enda,
        payment_date: values['payment_date'],
        pd: p_d,
        end_date: values['end_date'],
        next_date: values['next_date'],
        amount: am,
        //purchase_order: values['purchase_order'],
        details: values["details"],
        type: values["type"],
        status: stts
        /* reciept:values['reciept'],
        invoice:values['invoice'], */
      }
     //console..log(des)
      // save new Order
      this.setState({ repair: newRepair })
      this.addNewRepair(newRepair)
    }
    this.setState({ selectedRepair: null })
    //this.toggle()
  }




  deleteRepair = (repair) => {

   //console..log(tax)
    /* var v_u=[]
    var count=0
     this.state.vehicles.map(function (item) {
       if (item.plate_number === repair.plate_number) {
         if(item.status==="unavailable"){
           
           const ad = Moment(new Date()).format('YYYY-MM-DDTHH:mm')
           
           v_u.push({id:item.id,available_date:ad,start_date:"",status:"available"})
         }
       }
 
     })
     
     //console.log(count,v_u.length)
     if( v_u.length!==0){
       //console.log("dkhel")
       this.updateVehicle(v_u[0])
     }
     */
    const collection = firebase.firestore().collection("users").doc(this.state.user_id).collection("repairs")
    const timeline = {
      statusTitle: "Maintenance deleted",
      iconClass: "bx bx-wrench h2 text-danger",
      description: "Maintenance information has been deleted for ",
      data: repair.vehicle,
      time: new Date().getTime(),

    }
    collection.doc(repair.id).delete().then(() => {


      //console.log("Element  deleted!");
      toast.success(this.props.t("Maintenance  deleted!"))
      this.addNewTimeline(timeline)
      this.setState({
        success_dlg: true,
        dynamic_title: this.props.t("Deleted"),
        dynamic_description: this.props.t("Element has been deleted."),
      })
    }).catch((error) => {
     //console..error("Error removing element: ", error);
      toast.error(this.props.t("Error removing element"));

    });
  }

  updateRepair = async (repair) => {
    const { repairs, reservations } = this.state
    const collection = firebase.firestore().collection("users").doc(this.state.user_id).collection("repairs")
    this.setState({ submitLoading: true })
    const timeline = {
      statusTitle: "Maintenance updated",
      iconClass: "bx bx-wrench h2 text-warning",
      description: "Maintenance information has been updated for ",
      data: repair.vehicle,
      time: new Date().getTime(),

    }
    var rp = []
    var exist = false
    repairs.map(function (item, i) {
      if (repair.plate_number === item.plate_number) {
        rp.push({ start_date: item.start_date, end_date: item.end_date, id: item.id })
      }
    })
    reservations.map(function (item, i) {
      if (item.status === "Rental" || item.status === "Created") {
        if (repair.plate_number === item.plate_number) {
          rp.push({ start_date: item.pickup_date, end_date: item.return_date, id: item.id })
        }
      }
    })

    if (rp.length != 0) {
      rp.forEach(e => {
        if (e.id !== repair.id) {
          if ((new Date(e.start_date).getTime() >= new Date(repair.start_date).getTime() && new Date(e.start_date).getTime() <= new Date(repair.end_date).getTime()) ||
            (new Date(repair.start_date).getTime() >= new Date(e.start_date).getTime() && new Date(repair.start_date).getTime() <= new Date(e.end_date).getTime())) {
            exist = true
          }
        }
      });
    } else {
      exist = false
    }
    if (new Date(repair.start_date).getTime() < new Date(repair.end_date).getTime()) {
      if (!exist) {
        var nd = ""
        if (repair.next_date !== undefined) {
          nd = repair.next_date
        }

        try {
          // Get current document to check for existing files
          const currentDoc = await collection.doc(repair.id).get();
          const currentData = currentDoc.data();

          // Handle invoice file update
          let repairData = currentData.repairDoc || null;
          if (this.state.selectedFiles.repair) {
            // Delete old file if it exists
            if (currentData.repairDoc?.path) {
              await this.deleteFile(currentData.repairDoc.path);
            }
            // Upload new file
            repairData = await this.uploadFile(this.state.selectedFiles.repair, 'repair');
          }

          // Handle receipt file update
          let receiptData = currentData.receiptDoc || null;
          if (this.state.selectedFiles.receipt) {
            // Delete old file if it exists
            if (currentData.receiptDoc?.path) {
              await this.deleteFile(currentData.receiptDoc.path);
            }
            // Upload new file
            receiptData = await this.uploadFile(this.state.selectedFiles.receipt, 'receipt');
          }

          // Handle other file update
          let otherData = currentData.otherDoc || null;
          if (this.state.selectedFiles.other) {
            // Delete old file if it exists
            if (currentData.otherDoc?.path) {
              await this.deleteFile(currentData.otherDoc.path);
            }
            // Upload new file
            otherData = await this.uploadFile(this.state.selectedFiles.other, 'other');
          }

          // Update document with new data
          await collection.doc(repair.id).update({

            //label: repair.label,
            workshop: repair.workshop,
            workshop_id: repair.workshop_id,/* 
          vehicle: repair.vehicle,
          plate_number: repair.plate_number, */
            start_date: repair.start_date,
            start: repair.start,
            end: repair.end,
            title: repair.title,
            tenDays: repair.tenDays,
            sd: repair.sd,
            ed: repair.ed,
            end_date: repair.end_date,
            next_date: nd,
            payment_date: repair.payment_date,
            pd: repair.pd,
            amount: repair.amount,
            //purchase_order: repair.purchase_order,
            details: repair.details,
            type: repair.type,
            status: repair.status,
            // Update document fields only if new files were uploaded
            ...(repairData && {
              repairDoc: repairData
            }),
            ...(receiptData && {
              receiptDoc: receiptData
            }),
            ...(otherData && {
              otherDoc: otherData
            })


          });
          //console.log("Maintenance  Updated!");
          toast.success(this.props.t("Maintenance  Updated!"))
          this.addNewTimeline(timeline)
          this.setState({
            submitLoading: false,
            selectedFiles: { repair: null, receipt: null, other: null },
            uploadProgress: { repair: 0, receipt: 0, other: 0 }
          });
          this.toggle()
        } catch (error) {
         //console..error("Error updating maintenance: ", error);
          toast.error(this.props.t("Error updating maintenance"))
          this.setState({ submitLoading: false })
        }


      } else {
       //console..error("Error Updating Maintenance: Vehicle unavailable ");
        toast.error(this.props.t("Error Updating Maintenance : Vehicle unavailable"))
        this.setState({ submitLoading: false })
      }
    } else {
     //console..error("Error Updating Maintenance: Invalid dates ");
      toast.error(this.props.t("Error Updating Maintenance : Invalid dates"))
      this.setState({ submitLoading: false })
    }
  }
  addNewTimeline = async (timeline) => {
    const branch = JSON.parse(localStorage.getItem("branch"));
  
    if (!branch) {
     //toast.error("Error: Branch not found");
      this.setState({ loading: false });
      return;
    }
    try {
      const { user_id, account_user } = this.state;
      const collection = firebase.firestore().collection("users").doc(user_id).collection("timeline");
      const newDoc = collection.doc();
      const by = account_user.isAdmin ? 'Admin' : `${account_user.first_name} ${account_user.last_name}`;

      await newDoc.set({
        id: newDoc.id,
        statusTitle: timeline.statusTitle,
        iconClass: timeline.iconClass,
        description: timeline.description,
        time: timeline.time,
        data: timeline.data,
        branchId:branch,
        user: by
      });

      //console.log("Timeline  written!");
    } catch (error) {
     //console..error("Error adding timeline:", error);
    }
  }
  addNewRepair = async (repair) => {
    const branch = JSON.parse(localStorage.getItem("branch"));
  
    if (!branch) {
     //toast.error("Error: Branch not found");
      this.setState({ loading: false });
      return;
    }
    const { repairs, reservations } = this.state
    const collection = firebase.firestore().collection("users").doc(this.state.user_id).collection("repairs")
    this.setState({ submitLoading: true })

    const timeline = {
      statusTitle: "Maintenance added",
      iconClass: "bx bx-wrench h2 text-success",
      description: "Maintenance information has been added ",
      data: repair.vehicle,
      time: new Date().getTime(),

    }
    var rp = []
    var exist = false
    repairs.map(function (item, i) {
      if (repair.plate_number === item.plate_number) {
        rp.push({ start_date: item.start_date, end_date: item.end_date, id: item.id })
      }
    })
    reservations.map(function (item, i) {
      if (item.status === "Rental" || item.status === "Created") {
        if (repair.plate_number === item.plate_number) {
          rp.push({ start_date: item.pickup_date, end_date: item.return_date, id: item.id })
        }
      }
    })

    if (rp.length != 0) {
      rp.forEach(e => {

        if ((new Date(e.start_date).getTime() >= new Date(repair.start_date).getTime() && new Date(e.start_date).getTime() <= new Date(repair.end_date).getTime()) ||
          (new Date(repair.start_date).getTime() >= new Date(e.start_date).getTime() && new Date(repair.start_date).getTime() <= new Date(e.end_date).getTime())) {
          exist = true
        }
      });
    } else {
      exist = false
    }
    if (new Date(repair.start_date).getTime() < new Date(repair.end_date).getTime()) {
      if (!exist) {
        var nd = ""
        if (repair.next_date !== undefined) {
          nd = repair.next_date
        }
        try {
          // Upload files first if they exist
          const [repairFile, receiptFile, otherFile] = await Promise.all([
            this.uploadFile(this.state.selectedFiles.repair, 'repair'),
            this.uploadFile(this.state.selectedFiles.receipt, 'receipt'),
            this.uploadFile(this.state.selectedFiles.other, 'other')
          ]);

          var newDoc = collection.doc();
          await newDoc.set(
            {
              id: newDoc.id,
              // label: repair.label,
              workshop: repair.workshop,
              workshop_id: repair.workshop_id,
              vehicle: repair.vehicle,
              v_id: repair.v_id,
              plate_number: repair.plate_number,
              start_date: repair.start_date,
              start: repair.start,
              end: repair.end,
              title: repair.title,
              tenDays: repair.tenDays,
              sd: repair.sd,
              ed: repair.ed,
              end_date: repair.end_date,
              next_date: nd,
              payment_date: repair.payment_date,
              pd: repair.pd,
              amount: repair.amount,
              //purchase_order: repair.purchase_order,
              details: repair.details,
              type: repair.type,
              status: repair.status,
              branchId:branch,
              createdAt: new Date().getTime(),
              // Add document data if files were uploaded
              ...(repairFile && {
                repairDoc: {
                  path: repairFile.path,
                  url: repairFile.url
                }
              }),
              ...(receiptFile && {
                receiptDoc: {
                  path: receiptFile.path,
                  url: receiptFile.url
                }
              }),
              ...(otherFile && {
                otherDoc: {
                  path: otherFile.path,
                  url: otherFile.url
                }
              })

            });

          //console.log("Maintenance  written!");
          toast.success(this.props.t('Maintenance added '))
          this.addNewTimeline(timeline)
          this.setState({
            submitLoading: false,
            selectedFiles: { repair: null, receipt: null, other: null },
            uploadProgress: { repair: 0, receipt: 0, other: 0 }
          });
          this.toggle()
        } catch (error) {
         //console..error("Error Adding Maintenance infos: ", error);
          toast.error(this.props.t("Error Adding Maintenance infos"))
          this.setState({ submitLoading: false })
        }


      } else {
       //console..error("Error Adding Maintenance: Vehicle unavailable ");
        toast.error(this.props.t("Error Adding Maintenance : Vehicle unavailable"))
        this.setState({ submitLoading: false })
      }
    } else {
     //console..error("Error Adding Maintenance: Invalid dates ");
      toast.error(this.props.t("Error Adding Maintenance : Invalid dates"))
      this.setState({ submitLoading: false })
    }

  }


  handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format('DD MMM Y');
    return date1;
  }


  /* updateVehicle = async (vehicle) => {
    
    const collection = firebase.firestore().collection("users").doc(firebase.auth().currentUser.uid).collection("vehicles")
    collection.doc(vehicle.id).update({
      status: vehicle.status,
      available_date: vehicle.available_date,
      start_date:vehicle.start_date

    }).then(() => {
      //console.log("vehicle  Updated!");
    }).catch((error) => {
     //console..error("Error updating vehicle: ", error);
    });
  }

 */
  handleFileChange = (event, documentType) => {
    const file = event.target.files[0];
    const maxSize = 5 * 1024 * 1024; // 5MB limit

    if (file) {

      if (file.size > maxSize) {
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            [documentType]: 'File size should not exceed 5MB'
          }
        }));
        return;
      }

      if (!file.type.match('image.*') && !file.type.match('application/pdf')) {
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            [documentType]: 'Please upload an image or PDF file'
          }
        }));
        return;
      }

      this.setState(prevState => ({
        documents: {
          ...prevState.documents,
          [documentType]: file
        },
        errors: {
          ...prevState.errors,
          [documentType]: ''
        }
      }));
      this.setState(prevState => ({
        selectedFiles: {
          ...prevState.selectedFiles,
          [documentType]: file
        }
      }));

      // Create preview for images only
      if (file.type.match('image.*')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.setState(prevState => ({
            previews: {
              ...prevState.previews,
              [documentType]: reader.result
            }
          }));
        };
        reader.readAsDataURL(file);
      } else {
        this.setState(prevState => ({
          previews: {
            ...prevState.previews,
            [documentType]: null
          }
        }));
      }
    }
  }

  deleteFile = async (filePath) => {
    if (!filePath) return;

    try {
      const storageRef = firebase.storage().ref();
      const fileRef = storageRef.child(filePath);
      await fileRef.delete();
    } catch (error) {
     //console..error("Error deleting file:", error);
      // Continue execution even if delete fails
    }
  };


  uploadFile = async (file, type) => {
    if (!file) return null;

    const storageRef = firebase.storage().ref();
    const fileExtension = file.name.split('.').pop();
    const fileName = `${this.state.user_id}/maintenances-documents/${type}-${Date.now()}.${fileExtension}`;
    const fileRef = storageRef.child(fileName);

    try {
      const uploadTask = fileRef.put(file);

      // Monitor upload progress if needed
      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState(prevState => ({
            uploadProgress: {
              ...prevState.uploadProgress,
              [type]: progress
            }
          }));
        }
      );

      await uploadTask;
      const downloadURL = await fileRef.getDownloadURL();
      return { path: fileName, url: downloadURL };
    } catch (error) {
     //console..error(`Error uploading ${type}:`, error);
      toast.error(`Error uploading ${type}`);
      return null;
    }
  };

  render() {
    const emptyDataMessage = () => {
      return <Container>
        <Row>
          <Col lg="12">
            {this.state.loading ?
              <div className="text-center">
                <Row className="justify-content-center mt-5">
                  <Col sm="4">
                    <div>
                      <div >
                        <div className="spinner-chase">
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              :
              <div className="text-center">

                <Row className="justify-content-center mt-5">
                  <Col sm="4">
                    <div className="maintenance-img">
                      <img
                        src={maintanence}
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </Col>
                </Row>
                <h4 className="mt-5">{this.props.t("Let's get started with Medios")}</h4>
                <p className="text-muted">
                  {this.props.t("Start adding your maintenance informations by clicking ")}<h5 className="text-primary"><Link to="#" onClick={this.handleRepairClicks} >{this.props.t("New Maintenance")}</Link></h5>
                </p>
              </div>
            }
          </Col>
        </Row>
      </Container>
        ;
    }
    const { errors, previews, repairPermissions, currentYear, selectedVehicle1, selectedOption, selectedTS, selectedDate, selectedPeriod, repairs } = this.state
    //console.log(repairPermissions)
    var reqNext = false
    if (this.state.repair.type === "Oil change" || this.state.repair.type === "Inspection") {


      reqNext = true

    } else {

      reqNext = false

    }
    var rep
    rep = repairs
    const data = repairs;

    //console.log(selectedOption)
    switch (selectedOption) {
      case 'todo':
        var r = []
        repairs.map(function (item) {
          if (selectedVehicle1 === 1) {
            r.push(item)
          }
          if (item.v_id === selectedVehicle1) {
            r.push(item)
          }
        });

        rep = r
        break;
      case 'hoy':
        var r = []
        repairs.map(function (item) {
          var sd = moment(new Date()).format('MM-DD-YYYY')
          var ds = moment(item.createdAt).format("MM-DD-YYYY");
          var t = moment(ds)
          var s = moment(sd)
          if (s.isSame(t, 'day') && selectedVehicle1 === 1) {
            r.push(item)
          }
          if (s.isSame(t, 'day') && item.v_id === selectedVehicle1) {
            r.push(item)
          }
        });

        rep = r
        break;
      case 'sempa':
        var r = []
        repairs.map(function (item) {
          if (moment(new Date().getTime()).isSame(moment(item.createdAt), 'week') && selectedVehicle1 === 1) {
            r.push(item)
          }
          if (moment(new Date().getTime()).isSame(moment(item.createdAt), 'week') && item.v_id === selectedVehicle1) {
            r.push(item)
          }
        });

        rep = r
        break;
      case 'mespa':
        var r = []
        repairs.map(function (item) {
          if (moment(new Date().getTime()).isSame(moment(item.createdAt), 'month') && selectedVehicle1 === 1) {
            r.push(item)
          }
          if (moment(new Date().getTime()).isSame(moment(item.createdAt), 'month') && item.v_id === selectedVehicle1) {
            r.push(item)
          }
        });


        rep = r
        break;
      case 'dia':
        //console.log("diaaaaa")
        var r = []
        repairs.map(function (item) {
          var sd = moment(selectedTS).format('MM-DD-YYYY')
          var ds = moment(item.createdAt).format("MM-DD-YYYY");
          var t = moment(ds)
          var s = moment(sd)
          if (s.isSame(t, 'day') && selectedVehicle1 === 1) {
            r.push(item)
          }
          if (s.isSame(t, 'day') && item.v_id === selectedVehicle1) {
            r.push(item)
          }
        });
        rep = r
        break;
      case 'mes':
        //console.log("meeeees")
        var r = []
        repairs.map(function (item) {
          if (moment(selectedTS).isSame(moment(item.createdAt), 'month') && selectedVehicle1 === 1) {
            r.push(item)
          }
          if (moment(selectedTS).isSame(moment(item.createdAt), 'month') && item.v_id === selectedVehicle1) {
            r.push(item)
          }
        });

        rep = r
        break;
      case 'ano':
        //console.log("anooooo")
        var r = []
        repairs.map(function (item) {
          if (moment(selectedTS).isSame(moment(item.createdAt), 'year') && selectedVehicle1 === 1) {
            r.push(item)
          }
          if (moment(selectedTS).isSame(moment(item.createdAt), 'year') && item.v_id === selectedVehicle1) {
            r.push(item)
          }
        });


        rep = r
        break;
      default:

    }
    //console.log(rep)
    let dataxcl = []
    rep.map(function (item) {
      delete item.repair;
      dataxcl.push({
        //label: item.label,
        vehicle: item.vehicle,
        plate_number: item.plate_number,
        workshop: item.workshop,
        type: item.type,
        //workshop_id: item.workshop_id,
        start_date: item.start_date,
        payment_date: item.payment_date,
        end_date: item.end_date,
        next_date: item.next_date,
        amount: item.amount,
        // purchase_order: item.purchase_order,
        details: item.details

      })
    });
    const { selectedType } = this.state
    const { selectedVehicle } = this.state
    const { selectedWorkshop } = this.state
    const { SearchBar } = Search
    const { isEdit } = this.state
    const { isDelete } = this.state
    const { vc } = this.state
    const { vehicles } = this.state
    const { reservations } = this.state
    const { workshops } = this.state
    const { vehList } = this.state
    //pagination customization
   //console..log(vehList)
    let vcList = []
    const vcList1 = []
    const wsList = []
    vcList1.push({ label: "All vehicles", value: "All" })
    vehicles.map(function (item, i) {

      vcList1.push({ id: item.id, label: item.make + "(" + item.plate_number + ")", value: item.plate_number })

    })
    vcList.push({ label: "", value: "" })
    vehicles.map(function (item, i) {
      vcList.push({ id: item.id, label: item.make + ' (' + item.plate_number + ')', value: item.plate_number })

    })
    //console.log(vcList.length)
   //console..log(vehicles)
    /*  reservations.map((e, key) => {
       vcList.map((i, k) => {
 
         if (i.value === e.plate_number) {
           if (e.status === "Created") {
 
             //console.log(i)
             vcList.splice(k, 1)
 
           }
         }
       }) */


    /* vcList.map((i, k) => {
      if(i.value===e.plate_number ){
        if(e.status==="Created"){
         //console..log("kayn at : "+k)
         
          
        }
      }
    }) */
    // })
    //console.log(vcList.length)



    workshops.map(function (item, i) {
      wsList.push({ label: item.workshop_name, value: item.workshop_name })

    })



    const defaultSorted = [{
      dataField: 'createdAt',
      order: 'desc'
    }];

    const selectRow = {
      mode: 'checkbox',
    };

    const optionType =
      [
        { label: "", value: "" },
        { label: this.props.t("Maintenance"), value: "Maintenance" },
        { label: this.props.t("Repair"), value: "Repair" },
        { label: this.props.t("Accident repair"), value: "Accident repair" },
        { label: this.props.t("Oil change"), value: "Oil change" },
        { label: this.props.t("Inspection"), value: "Inspection" },
      ]

    function ExportToExcel() {
      exportFromJSON({ data: dataxcl, fileName: 'Maintenance', exportType: exportFromJSON.types.xls })
    }
    function exportPDF() {
      const unit = "pt";
      const size = "A4"; // Use A1, A2, A3 or A4
      const orientation = "landscape"; // portrait or landscape

      const marginLeft = 20;
      const doc = new jsPDF(orientation, unit, size);

      doc.setFontSize(15);

      const title = "Maintenance Infos";
      const headers = [["label", "Workshop", "Vehicle", "Start date", "End date", "Type", "amount", "Details"]];

      const dt = dataxcl.map(elt => [elt.label, elt.workshop, elt.vehicle, elt.start_date, elt.end_date, elt.type, elt.amount, elt.details]);

      let content = {
        startY: 50,
        head: headers,
        body: dt
      };

      doc.text(title, marginLeft, 20);
      doc.autoTable(content);
      doc.save("Maintenance.pdf")
    }
    function printPDF() {
      const unit = "pt";
      const size = "A4"; // Use A1, A2, A3 or A4
      const orientation = "landscape"; // portrait or landscape

      const marginLeft = 20;
      const doc = new jsPDF(orientation, unit, size);

      doc.setFontSize(15);

      const title = "Maintenance Infos";
      const headers = [["label", "Workshop", "Vehicle", "Start date", "End date", "Type", "amount", "Details"]];

      const dt = data.map(elt => [elt.label, elt.workshop, elt.vehicle, elt.start_date, elt.end_date, elt.type, elt.amount, elt.details]);


      let content = {
        startY: 50,
        head: headers,
        body: dt
      };

      doc.text(title, marginLeft, 20);
      doc.autoTable(content);
      var string = doc.output('datauristring');
      var embed = "<embed width='100%' height='100%' src='" + string + "'/>"
      var x = window.open();
      x.document.open();
      x.document.write(embed);
      x.document.close();

    }

    return (

      <React.Fragment>


        <div className="page-content">
          <MetaTags>
            <title>{this.props.t("Maintenance | Medios - Car Rental Management System")}</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title={this.props.t("Fleet")} breadcrumbItem={this.props.t("Maintenance")} />
            {this.state.success_dlg ? (
              <SweetAlert
                success
                title={this.state.dynamic_title}
                onConfirm={() => this.setState({ success_dlg: false })}
              >
                {this.state.dynamic_description}
              </SweetAlert>
            ) : null}
            <Row className="mb-2" >

              <Row>

                <Col dm="3" className="text-sm-center mb-2">
                  <AvForm>
                    <AvField
                      name="title"
                      type="select"
                      onChange={this.handleSelectVehicleFilter}
                      validate={{
                        required: { value: true },
                      }}

                    >
                      {vcList1.map((e, key) => {

                        return <option key={key} value={e.id}>{e.label}</option>;

                      })}</AvField>
                  </AvForm>



                </Col>
                <Col md="6" >
                  <div className="text-end " >

                    <Col   >

                      <div className="btn-group me-2" role="group" aria-label="Basic radio toggle button group" onChange={this.onChangeValue}>
                        <input type="radio" className="btn-check" name="btnradio" id="todo" onClick={this.onValueChange} autoComplete="off" defaultChecked />
                        <label className="btn btn-primary" htmlFor="todo">{this.props.t("All")}</label>

                        <input type="radio" className="btn-check" name="btnradio" id="hoy" onClick={this.onValueChange} autoComplete="off" />
                        <label className="btn btn-primary" htmlFor="hoy">{this.props.t("Today")}</label>

                        <input type="radio" className="btn-check" name="btnradio" id="sempa" onClick={this.onValueChange} autoComplete="off" />
                        <label className="btn btn-primary" htmlFor="sempa">{this.props.t("This week")}</label>

                        <input type="radio" className="btn-check" name="btnradio" id="mespa" onClick={this.onValueChange} autoComplete="off" />
                        <label className="btn btn-primary" htmlFor="mespa">{this.props.t("This month")}</label>

                        <button
                          type="button"
                          className="btn btn-light mb-2"
                          onClick={this.toggle_modal}
                        >
                          <i className="bx bx-filter  font-size-22 align-middle "></i>

                        </button>
                      </div>

                    </Col>

                  </div>
                </Col>


                <Modal
                  isOpen={this.state.modal1}
                  toggle={this.toggle_modal}
                  id="event-modal"
                >
                  <ModalHeader toggle={this.toggle_modal} tag="h4">
                    {this.props.t("Custom Period")}
                  </ModalHeader>
                  <ModalBody>
                    <AvForm onValidSubmit={this.handleValidEventSubmit}>
                      <Row form>
                        <Col className="col-12 mb-3">

                          {/* <AvField
  name="title"
  label="Vehicles"
  type="select"
  onChange={this.handleSelectVehicle}
  validate={{
    required: { value: true },
  }}

>
  {vcList.map((e, key) => {

    return <option key={key} value={e.id}>{e.label}</option>;

  })}</AvField> */}
                        </Col>
                        <Col className="col-12 mb-3">
                          <AvField
                            type="select"
                            name="period"
                            label={this.props.t("Select Period")}
                            defaultValue={selectedPeriod}
                            validate={{
                              required: { value: true },
                            }}
                            onChange={this.handlePeriodChange}
                          >
                            <option value="day">{this.props.t("Day")}</option>
                            <option value="month">{this.props.t("Month")}</option>
                            <option value="year">{this.props.t("Year")}</option>
                          </AvField>
                        </Col>

                        {selectedPeriod === "day" ?
                          <div className="mb-3 mt-4 row">
                            <label
                              htmlFor="example-month-input"
                              className="col-md-2 col-form-label"
                            >
                              {this.props.t("Day")}
                            </label>

                            <div className="col">
                              <AvField
                                className="form-control text-sm-start"
                                name="date"
                                type="date"
                                onChange={this.dateChanged}
                                id="example-date-input"
                                validate={{
                                  required: { value: true },
                                }}
                              />
                            </div>
                          </div>
                          : null}
                        {selectedPeriod === "month" ?
                          <div className="mb-6 row mb-3">
                            <label
                              htmlFor="example-month-input"
                              className="col-md-2 col-form-label"
                            >
                              {this.props.t("Month")}
                            </label>
                            <div className="col">
                              <AvField
                                name="month"
                                className="form-control"
                                type="month"
                                onChange={this.monthChanged}
                                id="example-month-input"
                                validate={{
                                  required: { value: true },
                                }}
                              />
                            </div>
                          </div>
                          : null}
                        {selectedPeriod === "year" ?
                          <div className="mb-3 row mb-3">
                            <AvField
                              type="select"
                              name="year"
                              label={this.props.t("Select year")}
                              defaultValue={currentYear}
                              validate={{
                                required: { value: true },
                              }}
                            >
                              <option value={currentYear}>{currentYear}</option>
                              <option value={currentYear - 1}>{currentYear - 1}</option>
                              <option value={currentYear - 2}>{currentYear - 2}</option>
                              <option value={currentYear - 3}>{currentYear - 3}</option>
                              <option value={currentYear - 4}>{currentYear - 4}</option>
                            </AvField>
                          </div>
                          : null}
                      </Row>
                      {/* <h5 className="text-center mt-4">
{this.state.selectedDate || this.state.selectedMonth}
</h5> */}
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-light"
                          data-dismiss="modal"
                          onClick={this.toggle_modal}
                        >
                          {this.props.t("Close")}
                        </button>

                        <button
                          type="submit"
                          className="btn btn-success"
                        >
                          {this.props.t("Confirm")}
                        </button>
                      </div>
                    </AvForm>
                  </ModalBody>


                </Modal>

              </Row>

            </Row>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory()}
                      keyField='id'
                      columns={(this.state.RepairColumns || [])}
                      data={(rep || [])}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={rep}
                          columns={(this.state.RepairColumns || [])}
                          bootstrap4
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="mb-2" class="noPrint">
                                <Col sm="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>

                                <Col sm="8" >

                                  <div className="text-sm-end" >
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={this.handleRepairClicks}
                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      {this.props.t("New Maintenance")}
                                    </Button>

                                    <Link to="#"

                                    >

                                      {/*  <i className="mdi mdi-file-export-outline font-size-18" /> */}
                                      <td>
                                        <UncontrolledDropdown>
                                          <DropdownToggle href="#" className="card-drop" tag="a">
                                            <i className="mdi mdi-dots-vertical font-size-18" />
                                          </DropdownToggle>
                                          <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#" onClick={() => rep.length == 0 ? this.setState({ no_data: true }) : exportPDF()}>
                                              <i className="mdi mdi-file-pdf-box font-size-16 text-danger me-1" />{" "}
                                              {this.props.t("Export PDF")}

                                            </DropdownItem>
                                            <DropdownItem href="#" onClick={() => rep.length == 0 ? this.setState({ no_data: true }) : ExportToExcel()} >

                                              <i className="mdi mdi-microsoft-excel font-size-16 text-success me-1" />{" "}
                                              {this.props.t("Export Excel")}
                                            </DropdownItem>
                                            <DropdownItem href="#" onClick={() => rep.length == 0 ? this.setState({ no_data: true }) : printPDF()}>
                                              <i className="mdi mdi-printer font-size-16 text-grey me-1" />{" "}
                                              {this.props.t("Print")}
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </UncontrolledDropdown>

                                      </td>
                                    </Link>
                                  </div>
                                </Col>
                              </Row>
                              <div className="table-responsive">
                                <BootstrapTable

                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  defaultSorted={defaultSorted}
                                  bordered={false}
                                  striped={false}
                                  noDataIndication={emptyDataMessage}
                                  classes={
                                    "table align-middle table-nowrap table-check"
                                  }
                                  headerWrapperClasses={"table-light"}
                                />
                                <Modal
                                  isOpen={this.state.modalDenied}
                                  role="alert"
                                  autoFocus={true}
                                  data-toggle="modalDenied"
                                  centered
                                  size="md"
                                >
                                  <ModalHeader toggle={this.toggleDenied} tag="h4">     </ModalHeader>

                                  <Row className="justify-content-center">
                                    <Col >

                                      <div className="p-2 mt-4 mb-0">
                                        <div className="text-center">
                                          <div className="avatar-md mx-auto">
                                            <div className="avatar-title rounded-circle bg-light">
                                              <i className="mdi mdi-shield-lock-outline h1 mt-4 text-primary mdi-48px"></i>
                                            </div>
                                          </div>
                                          <div className="p-2 mt-3 mb-0">
                                            <h4>{this.props.t("Permission Denied !")}</h4>
                                            <br />
                                            <p>


                                              {this.props.t("You do not have the required permissions to perform this action.")}<br /> {this.props.t("Please contact the administrator for assistance.")}

                                            </p>

                                          </div>
                                        </div>
                                      </div>

                                    </Col>
                                  </Row>
                                </Modal>
                                <Modal
                                  isOpen={this.state.modal}
                                  className={this.props.className}
                                >
                                  <ModalHeader toggle={this.toggle} tag="h4">
                                    {!!isEdit ? this.props.t("Edit Maintenance infos") : null}
                                    {!!this.state.isShow ? this.props.t("Maintenance Infos") : null}
                                    {!isEdit && !this.state.isShow ? this.props.t("Add Maintenance") : null}
                                  </ModalHeader>
                                  <ModalBody>
                                    {this.state.submitLoading ?
                                      <Col>
                                        <div>
                                          <div >
                                            <div className="spinner-chase">
                                              <div className="chase-dot"></div>
                                              <div className="chase-dot"></div>
                                              <div className="chase-dot"></div>
                                              <div className="chase-dot"></div>
                                              <div className="chase-dot"></div>
                                              <div className="chase-dot"></div>
                                            </div>
                                          </div>
                                        </div>
                                        <br />
                                        <h6 className='text-center'>{this.props.t("Uploading data ...")}</h6>
                                      </Col>

                                      :

                                      <AvForm
                                        onValidSubmit={
                                          this.handleValidRepairSubmit
                                        }
                                        disabled={this.state.isShow ? true : false}
                                      >
                                        {/* <Row>
                                          <Col md="12">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor="validationCustom01">
                                                {this.props.t("Label")}
                                              </Label>
                                              <AvField
                                                name="label"
                                                placeholder={this.props.t("Label")}
                                                type="text"
                                                errorMessage={this.props.t("Enter Label")}
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                value={this.state.repair.label || ""}

                                              />
                                            </FormGroup>
                                          </Col>

                                        </Row> */}


                                        <Row>

                                          <Col md="6">
                                            <FormGroup className="mb-3">
                                              <div className="mb-3 select2-container">
                                                <Label>{this.props.t("Vehicle")}</Label>
                                                {!isEdit && !this.state.isShow ?
                                                  <div>
                                                    <AvField
                                                      name="vehicle"
                                                      type="select"
                                                      placeholder={""}
                                                      //onChange={this.handleSelectVehicle}
                                                      //options={vcList}
                                                      //value={this.state.repair.vehicle}
                                                      disabled={this.state.isShow || !!isEdit ? true : false}
                                                      errorMessage={this.props.t("Select a Vehicle")}
                                                      className="form-control"

                                                      validate={{
                                                        required: { value: true },
                                                      }}
                                                    >

                                                      {vcList.map((e, key) => {
                                                        if (key == 0) {
                                                          return <option key={key} value="" disabled>{this.props.t("vehicle")}</option>;
                                                        } else {
                                                          return <option key={key} value={e.id}>{e.label}</option>;
                                                        }
                                                      })}
                                                    </AvField>
                                                    <Link to="/vehicles" target="_blank" rel="noopener noreferrer">{this.props.t("Add new Vehicle")}</Link>
                                                  </div>
                                                  :
                                                  <AvField
                                                    name="vehicle"
                                                    type="text"
                                                    disabled={this.state.isShow || !!isEdit ? true : false}
                                                    value={this.state.repair.vehicle || ""}
                                                  />
                                                }
                                              </div>

                                            </FormGroup>
                                          </Col>
                                          <Col md="6">
                                            <FormGroup className="mb-3">
                                              <div className="mb-3 select2-container">
                                                <Label>{this.props.t("Workshop")}</Label>
                                                <Select
                                                  name="workshop"
                                                  //placeholder={this.state.repairs.workshop}
                                                  onChange={this.handleSelectWorkshop}
                                                  options={wsList}
                                                  value={selectedWorkshop}
                                                  isDisabled={this.state.isShow ? true : false}

                                                />
                                                <Link to="/suppliers" target="_blank" rel="noopener noreferrer">{this.props.t("Add new Workshop")}</Link>
                                              </div>
                                            </FormGroup>
                                          </Col>
                                        </Row>

                                        <Row>
                                          <Col md="7">
                                            <FormGroup className="mb-3">
                                              <div className="mb-3 select2-container">
                                                <Label>{this.props.t("Maintenance Type")}</Label>
                                                <AvField
                                                  name="type"
                                                  type="select"
                                                  //placeholder={this.state.repairs.type}
                                                  onChange={this.handleSelectType}
                                                  //options={optionType}
                                                  value={this.state.repair.type}
                                                  //isDisabled={this.state.isShow ? true : false}
                                                  disabled={this.state.isShow || !!isEdit ? true : false}
                                                  errorMessage={this.props.t("Select maintenance type")}
                                                  className="form-control"

                                                  validate={{
                                                    required: { value: true },
                                                  }}
                                                >

                                                  {optionType.map((e, key) => {
                                                    if (key == 0) {
                                                      return <option key={key} value="" disabled>{this.props.t("type")}</option>;
                                                    } else {
                                                      return <option key={key} value={e.value}>{e.label}</option>;
                                                    }
                                                  })}
                                                </AvField>
                                              </div>
                                            </FormGroup>
                                          </Col>
                                          <Col md="5">
                                            <FormGroup className="mb-3">
                                              <AvField
                                                name="amount"
                                                label={this.props.t("Amount")}
                                                placeholder={this.props.t("Total amount")}
                                                errorMessage={this.props.t("Enter Amount")}
                                                type="number"
                                                validate={{ required: { value: true } }}
                                                value={this.state.repair.amount || ""}
                                              />
                                            </FormGroup>

                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col md="4">
                                            <FormGroup className="mb-4">
                                              <Label> {this.props.t("Start date")}</Label>
                                              <AvField
                                                name="start_date"
                                                type="datetime-local"
                                                defaultValue={this.state.repair.start_date || ""}
                                                errorMessage={this.props.t("Select start date")}
                                                //onChange={this.handleSDChange}
                                                disabled={this.state.isShow ? true : false}
                                                validate={{
                                                  required: { value: true },
                                                }}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md="4">
                                            <FormGroup className="mb-4">
                                              <Label> {this.props.t("End date")}</Label>
                                              <AvField
                                                name="end_date"
                                                type="datetime-local"
                                                defaultValue={this.state.repair.end_date || ""}
                                                errorMessage={this.props.t("Select end date")}
                                                // onChange={this.handleEDChange}
                                                disabled={this.state.isShow ? true : false}
                                                validate={{
                                                  required: { value: true },
                                                }}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md="4">
                                            <FormGroup className="mb-4">
                                              <Label>{this.props.t("Payment date")}</Label>
                                              <AvField
                                                name="payment_date"
                                                placeholder={this.props.t("Payment date")}
                                                type="date"
                                                validate={{
                                                  required: { value: true },
                                                }}
                                                value={Moment(this.state.repair.payment_date).format('YYYY-MM-DD') || ""}
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        {reqNext || this.state.reqNext ?
                                          <Row>
                                            <Col>
                                              <FormGroup className="mb-4">
                                                <Label> {this.props.t("Next date")}</Label>
                                                <AvField
                                                  name="next_date"
                                                  type="datetime-local"
                                                  defaultValue={this.state.repair.next_date || ""}
                                                  errorMessage={this.props.t("Select next date")}
                                                  // onChange={this.handleEDChange}
                                                  disabled={this.state.isShow ? true : false}
                                                  //disabled={this.state.isShow || !!isEdit ? true : false}
                                                  validate={{
                                                    required: { value: true },
                                                  }}
                                                />
                                              </FormGroup>
                                            </Col>
                                          </Row> : null}

                                        <Row>

                                          {!this.state.isShow ? <Label>{this.props.t("Upload invoice")}</Label> : null}
                                          {this.state.isShow && this.state.repair.repair_url !== "" ?

                                            <Row className="">
                                              <Col md={8}>
                                                <p className="mb-0"> {decodeURIComponent(this.state.repair.repair_url).split("/").pop().split("?")[0]}</p>
                                              </Col>
                                              <Col md={4} className="text-end">
                                                <Button
                                                  color="primary"
                                                  onClick={() => window.open(this.state.repair.repair_url, "_blank")}
                                                  download

                                                >
                                                  <i className="bx bx-download"></i>

                                                </Button>
                                              </Col>
                                            </Row>

                                            : null}
                                          {!this.state.isShow && !this.state.isEdit ? <FormGroup className=" ">

                                            <Input
                                              type="file"
                                              id="repair"
                                              name="repair"
                                              accept="image/*, application/pdf"
                                              onChange={(e) => this.handleFileChange(e, 'repair')}
                                              className=""
                                            />
                                            <FormText color="muted">
                                              {this.props.t("Upload a clear image or PDF (Max size - 5MB)")}
                                            </FormText>
                                            {errors.repair && (
                                              <Alert color="danger" className="mt-2">
                                                {errors.repair}
                                              </Alert>
                                            )}

                                          </FormGroup> : null}
                                          {!this.state.isShow && this.state.isEdit ? <> {this.state.repair.repair_url !== "" ? <Row className="mb-1">
                                            <Col md={8}>
                                              <p className="mb-0"> {decodeURIComponent(this.state.repair.repair_url).split("/").pop().split("?")[0]}</p>
                                            </Col>
                                            <Col md={4} className="text-end">
                                              <Button
                                                color="primary"
                                                onClick={() => window.open(this.state.repair.repair_url, "_blank")}
                                                download

                                              >
                                                <i className="bx bx-download"></i>

                                              </Button>
                                            </Col>
                                          </Row> : null}
                                            <FormGroup className="">
                                              {this.state.repair.repair_url !== "" ? <Label>{this.props.t("Replace file")}</Label> : null}<br />
                                              <Input
                                                type="file"
                                                id="repair"
                                                name="repair"
                                                accept="image/*, application/pdf"
                                                onChange={(e) => this.handleFileChange(e, 'repair')}
                                                className=""
                                              />
                                              <FormText color="muted">
                                                {this.props.t("Upload a clear image or PDF (Max size - 5MB)")}
                                              </FormText>
                                              {errors.repair && (
                                                <Alert color="danger" className="mt-2">
                                                  {errors.repair}
                                                </Alert>
                                              )}

                                            </FormGroup></> : null

                                          }
                                        </Row>
                                        <Row className="mt-1">

                                          {!this.state.isShow ? <Label>{this.props.t("Upload receipt")}</Label> : null}
                                          {this.state.isShow && this.state.repair.rec_url !== "" ?

                                            <Row className="mb-1">
                                              <Col md={8}>
                                                <p className="mb-0"> {decodeURIComponent(this.state.repair.rec_url).split("/").pop().split("?")[0]}</p>
                                              </Col>
                                              <Col md={4} className="text-end">
                                                <Button
                                                  color="primary"
                                                  onClick={() => window.open(this.state.repair.rec_url, "_blank")}
                                                  download

                                                >
                                                  <i className="bx bx-download"></i>

                                                </Button>
                                              </Col>
                                            </Row>

                                            : null}
                                          {!this.state.isShow && !this.state.isEdit ? <FormGroup className=" ">

                                            <Input
                                              type="file"
                                              id="receipt"
                                              name="receipt"
                                              accept="image/*, application/pdf"
                                              onChange={(e) => this.handleFileChange(e, 'receipt')}
                                              className=""
                                            />
                                            <FormText color="muted">
                                              {this.props.t("Upload a clear image or PDF (Max size - 5MB)")}
                                            </FormText>
                                            {errors.receipt && (
                                              <Alert color="danger" className="mt-2">
                                                {errors.receipt}
                                              </Alert>
                                            )}

                                          </FormGroup> : null}
                                          {!this.state.isShow && this.state.isEdit ? <> {this.state.repair.rec_url !== "" ? <Row className="mb-1">
                                            <Col md={8}>
                                              <p className="mb-0"> {decodeURIComponent(this.state.repair.rec_url).split("/").pop().split("?")[0]}</p>
                                            </Col>
                                            <Col md={4} className="text-end">
                                              <Button
                                                color="primary"
                                                onClick={() => window.open(this.state.repair.rec_url, "_blank")}
                                                download

                                              >
                                                <i className="bx bx-download"></i>

                                              </Button>
                                            </Col>
                                          </Row> : null}
                                            <FormGroup className="">
                                              {this.state.repair.rec_url !== "" ? <Label>{this.props.t("Replace file")}</Label> : null}<br />
                                              <Input
                                                type="file"
                                                id="receipt"
                                                name="receipt"
                                                accept="image/*, application/pdf"
                                                onChange={(e) => this.handleFileChange(e, 'receipt')}
                                                className=""
                                              />
                                              <FormText color="muted">
                                                {this.props.t("Upload a clear image or PDF (Max size - 5MB)")}
                                              </FormText>
                                              {errors.receipt && (
                                                <Alert color="danger" className="mt-2">
                                                  {errors.receipt}
                                                </Alert>
                                              )}

                                            </FormGroup></> : null

                                          }
                                        </Row>
                                        <Row className="">
                                          {!this.state.isShow ? <Label>{this.props.t("Other Document")}</Label> : null}

                                          {this.state.isShow && this.state.repair.other_url !== "" ?

                                            <Row className="mb-1">
                                              <Col md={8}>
                                                <p className="mb-0"> {decodeURIComponent(this.state.repair.other_url).split("/").pop().split("?")[0]}</p>
                                              </Col>
                                              <Col md={4} className="text-end">
                                                <Button
                                                  color="primary"
                                                  onClick={() => window.open(this.state.repair.other_url, "_blank")}
                                                  download

                                                >
                                                  <i className="bx bx-download"></i>

                                                </Button>
                                              </Col>
                                            </Row>

                                            : null}
                                          {!this.state.isShow && !this.state.isEdit ? <FormGroup className=" ">

                                            <Input
                                              type="file"
                                              id="other"
                                              name="other"
                                              accept="image/*, application/pdf"
                                              onChange={(e) => this.handleFileChange(e, 'other')}
                                              className="mb-1"
                                            />
                                            <FormText color="muted">
                                              {this.props.t("Upload a clear image or PDF (Max size - 5MB)")}
                                            </FormText>
                                            {errors.other && (
                                              <Alert color="danger" className="mt-2">
                                                {errors.other}
                                              </Alert>
                                            )}

                                          </FormGroup> : null}
                                          {!this.state.isShow && this.state.isEdit ? <> {this.state.repair.other_url !== "" ? <Row className="mb-1">
                                            <Col md={8}>
                                              <p className="mb-0"> {decodeURIComponent(this.state.repair.other_url).split("/").pop().split("?")[0]}</p>
                                            </Col>
                                            <Col md={4} className="text-end">
                                              <Button
                                                color="primary"
                                                onClick={() => window.open(this.state.repair.other_url, "_blank")}
                                                download

                                              >
                                                <i className="bx bx-download"></i>

                                              </Button>
                                            </Col>
                                          </Row> : null}
                                            <FormGroup className="">
                                              {this.state.repair.other_url !== "" ? <Label>{this.props.t("Replace file")}</Label> : null}<br />
                                              <Input
                                                type="file"
                                                id="other"
                                                name="other"
                                                accept="image/*, application/pdf"
                                                onChange={(e) => this.handleFileChange(e, 'other')}
                                                className=""
                                              />
                                              <FormText color="muted">
                                                {this.props.t("Upload a clear image or PDF (Max size - 5MB)")}
                                              </FormText>
                                              {errors.other && (
                                                <Alert color="danger" className="mt-2">
                                                  {errors.other}
                                                </Alert>
                                              )}

                                            </FormGroup></> : null

                                          }
                                        </Row>

                                        <Row>
                                          <Col md="12">

                                            <FormGroup className="mb-3">
                                              <Label htmlFor="validationCustom03">
                                                {this.props.t("Details")}
                                              </Label>
                                              <AvField
                                                name="details"
                                                placeholder={this.props.t("Maintenance Details")}

                                                type="textarea"
                                                rows="2"
                                                value={this.state.repair.details || ""}
                                              />
                                            </FormGroup>
                                          </Col>


                                        </Row>
                                        {/* <Row>

                                          <Col md="10" >
                                            <FormGroup className="mb-3">
                                              <AvField
                                                name="purchase_order"
                                                label={this.props.t("Purchase order")}
                                                placeholder={this.props.t("Purchase order id")}
                                                type="number"
                                                value={this.state.repair.purchase_order || ""}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md="2" >
                                            <FormGroup className="mb-3">

                                              <Link onClick={//console.log('')} >{this.props.t("Add new purchase order")}</Link>
                                            </FormGroup>
                                          </Col>

                                        </Row>

 */}
                                        {this.state.isShow ? null :
                                          <Row>
                                            <Col>
                                              <div className="text-end">

                                                <button
                                                  type="submit"
                                                  className="btn btn-success save-user"
                                                >
                                                  {this.props.t("Save")}
                                                </button>
                                              </div>
                                            </Col>
                                          </Row>
                                        }

                                      </AvForm>
                                    }
                                  </ModalBody>
                                </Modal>


                                {this.state.isDelete ? (
                                  <SweetAlert
                                    title={this.props.t("Are you sure?")}
                                    warning
                                    showCancel
                                    confirmButtonText={this.props.t("Yes, delete it!")}
                                    confirmBtnBsStyle="success"
                                    cancelBtnBsStyle="danger"
                                    onConfirm={() =>
                                      this.handleDeleteRepair(vc)
                                    }
                                    onCancel={() =>
                                      this.setState({
                                        isDelete: false,
                                      })
                                    }
                                  >
                                    {this.props.t("You won't be able to revert this!")}
                                  </SweetAlert>
                                ) : null}
                                {this.state.no_data ? (
                                  <SweetAlert
                                    title={this.props.t("No data!")}
                                    warning
                                    onConfirm={() => this.setState({ no_data: false })}
                                  >
                                    {this.props.t("There is no data to export")}
                                  </SweetAlert>
                                ) : null}

                              </div>

                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <Toaster
          position="top-right"
          reverseOrder={false}
        />
      </React.Fragment>
    )
  }
}

Repairs.propTypes = {
  repairs: PropTypes.array,
  vehicles: PropTypes.array,
  workshops: PropTypes.array,
  reservations: PropTypes.array,
  onGetRepair: PropTypes.func,
  onAddNewRepair: PropTypes.func,
  onDeleteRepair: PropTypes.func,
  onUpdateRepair: PropTypes.func,
  onGetVehicle: PropTypes.func,
  onGetReservation: PropTypes.func,
  onUpdateVehicle: PropTypes.func,
  onGetSupplier: PropTypes.func,
  className: PropTypes.any,
  t: PropTypes.any,
}

const mapStateToProps = state => ({
  repairs: state.maintenance.repairs,
  vehicles: state.vehicle.vehicles,
  workshops: state.supplier.suppliers,
  reservations: state.reservation.reservations,
})

const mapDispatchToProps = dispatch => ({
  onGetRepair: () => dispatch(getRepair()),
  onGetVehicle: () => dispatch(getVehicle()),
  onGetSupplier: () => dispatch(getSupplier()),
  onGetReservation: () => dispatch(getReservation()),
  onAddNewRepair: repair => dispatch(addNewRepair(repair)),
  onUpdateRepair: repair => dispatch(updateRepair(repair)),
  onDeleteRepair: repair => dispatch(deleteRepair(repair)),
  onUpdateVehicle: vehicle => dispatch(updateVehicle(vehicle)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Repairs)))
